"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.idAttribute = exports.key = void 0;
var lodash_1 = require("lodash");
var map_keys_deep_lodash_1 = __importDefault(require("map-keys-deep-lodash"));
var normalizr_1 = require("normalizr");
var sharedTypes_1 = require("../sharedTypes");
exports.key = sharedTypes_1.EntityKey.VIEWS;
exports.idAttribute = 'id';
var processStrategy = function (obj) { return (0, map_keys_deep_lodash_1.default)(obj, function (v, k) { return (0, lodash_1.camelCase)(k); }); };
exports.default = new normalizr_1.schema.Entity(exports.key, {}, { idAttribute: exports.idAttribute, processStrategy: processStrategy });
//# sourceMappingURL=schema.js.map